import * as React from "react";
import { View, StyleSheet, Text, useWindowDimensions } from "react-native";
import "./Ecosystem.css"; // Import the CSS file

function TitleSection() {
  const { width } = useWindowDimensions();
    const isMobile = width < 991;
    const responsiveStyles = isMobile ? stylesMobile : stylesDesktop;
  return (
    <View style={responsiveStyles.titleSection}>
      <View style={responsiveStyles.image} />
      <View style={responsiveStyles.content}>
        <View style={responsiveStyles.titleContainer}>
          {/* <Text style={responsiveStyles.title}> */}
          <div className="title">
            KIY (Web3 Security) Ecosystem
          </div>
          {/* </Text> */}
        </View>
        <View style={responsiveStyles.subtitleContainer}>
          <Text style={responsiveStyles.subtitle}>
            creates a secure, reliable, transparent, and open environment that
            genuinely empowers <br className="responsive-br"/>users.
          </Text>
        </View>
      </View>
    </View>
  );
}

const stylesMobile = StyleSheet.create({
  titleSection: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    maxWidth: "100%",
    textAlign: "center",
  },
  image: {
    position: "absolute",
    zIndex: 1,
    display: "flex",
    minHeight: 372,
    width: "100%",
    maxWidth: "100%",
    right: -32,
    bottom: -374,
    height: 372,
  },
  content: {
    zIndex: 1,
    width: "100%",
  },
  subtitleContainer: {
    // marginTop: 12,
  },
  subtitle: {
    color: "rgba(236, 236, 236, 1)",
    // marginTop: 15,
    fontSize: "12px",
    fontWeight: "400",
    // marginBottom: 5,
    lineHeight: 18,
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
  },
});

const stylesDesktop = StyleSheet.create({
  titleSection: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    maxWidth: "100%",
    textAlign: "center",
  },
  image: {
    position: "absolute",
    zIndex: 1,
    display: "flex",
    minHeight: 372,
    width: "100%",
    maxWidth: "100%",
    right: -32,
    bottom: -374,
    height: 372,
  },
  content: {
    zIndex: 1,
    width: "100%",
  },
  // titleContainer: {},
  // title: {
  //   fontSize: 40,
  //   fontWeight: "800",
  //   lineHeight: 45,
  //   letterSpacing: 1,
  //   color: "white",
  //   textAlign: "center",
  //   fontFamily: "Montserrat, sans-serif",
  // },
  subtitleContainer: {
    marginTop: 12,
  },
  subtitle: {
    color: "rgba(236, 236, 236, 1)",
    marginTop: 15,
    fontSize: 18,
    fontWeight: "400",
    // marginBottom: 5,
    lineHeight: 26,
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
  },
});

export default TitleSection;
